/**
 * Interval color and abbreviation mapping utilities
 */

/**
 * Color scheme for different maintenance intervals
 */
const INTERVAL_COLOR_MAP = {
  // Daily
  'day-1': { color: '#FF6B6B', abbreviation: 'D', fullName: 'Daily' },
  // Weekly
  'week-1': { color: '#e87dc7', abbreviation: 'W', fullName: 'Weekly' },
  // Every two weeks
  'week-2': { color: '#45B7D1', abbreviation: '2W', fullName: 'Every 2 weeks' },
  // Monthly
  'month-1': { color: '#96CEB4', abbreviation: 'M', fullName: 'Monthly' },
  // Every 3 months
  'month-3': { color: '#f9c556', abbreviation: '3M', fullName: 'Every 3 months' },
  // Every 6 months
  'month-6': { color: '#FFA07A', abbreviation: '6M', fullName: 'Every 6 months' },
  // Yearly
  'year-1': { color: '#DDA0DD', abbreviation: 'Y', fullName: 'Yearly' },
  // Every 2 years
  'year-2': { color: '#F0E68C', abbreviation: '2Y', fullName: 'Every 2 years' },
  // Every 3 years
  'year-3': { color: '#D3D3D3', abbreviation: '3Y', fullName: 'Every 3 years' },
  // Every 4 years
  'year-4': { color: '#D3D3D3', abbreviation: '4Y', fullName: 'Every 4 years' },
  // Every 5 years
  'year-5': { color: '#D3D3D3', abbreviation: '5Y', fullName: 'Every 5 years' },
  // Every 6 years
  'year-6': { color: '#D3D3D3', abbreviation: '6Y', fullName: 'Every 6 years' },
};

/**
 * Get interval indicator data (color, abbreviation, and fullName) from interval object
 * @param {Object} intervalValue - Interval value object with type and value properties
 * @param {string} intervalValue.type - Type of interval (day, week, month, year)
 * @param {number} intervalValue.value - Value of interval
 * @returns {Object} Object with color, abbreviation, and fullName properties
 */
export function getIntervalIndicator(intervalValue) {
  if (!intervalValue || !intervalValue.type || !intervalValue.value) {
    return { color: '#D3D3D3', abbreviation: '?', fullName: 'Unknown' };
  }

  const key = `${intervalValue.type}-${intervalValue.value}`;
  const indicator = INTERVAL_COLOR_MAP[key];

  if (indicator) {
    return indicator;
  }

  // Fallback for unmapped intervals
  return { color: '#D3D3D3', abbreviation: '?', fullName: 'Unknown' };
}

/**
 * Get interval indicator data from parsed interval string
 * @param {string} intervalString - JSON string of interval data
 * @returns {Object} Object with color, abbreviation, and fullName properties
 */
export function getIntervalIndicatorFromString(intervalString) {
  try {
    const intervalValue = JSON.parse(intervalString);
    return getIntervalIndicator(intervalValue);
  } catch (error) {
    console.warn('Failed to parse interval string:', intervalString);
    return { color: '#D3D3D3', abbreviation: '?', fullName: 'Unknown' };
  }
}

/**
 * Get all available interval color mappings for reference
 * @returns {Object} Complete interval color map
 */
export function getIntervalColorMap() {
  return { ...INTERVAL_COLOR_MAP };
}
